import { ADVERTISING_AGENCY_ITEM_TYPES } from '../lib/constants';
// ---- internal imports ----

class HiredTradeshowBooth {
	constructor(id, tradeshow, hiredTurnDate, startingTurnDate, payedPrice) {
		this.id = id;
		this.tradeshow = tradeshow;
		this.hiredTurnDate = hiredTurnDate;
		this.startingTurnDate = startingTurnDate;
		this.payedPrice = payedPrice;
		this.type = ADVERTISING_AGENCY_ITEM_TYPES.TRADESHOW;
	}

	toPlainObj() {
		return {
			id: this.id,
			tradeshow: this.tradeshow,
			hiredTurnDate: this.hiredTurnDate,
			startingTurnDate: this.startingTurnDate,
			payedPrice: this.payedPrice,
			type: this.type
		};
	}
}

function HiredTradeshowBoothBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withTradeshow: function (tradeshow) {
			this.tradeshow = tradeshow;
			return this;
		},
		withHiredTurnDate: function (hiredTurnDate) {
			this.hiredTurnDate = hiredTurnDate;
			return this;
		},
		withStartingTurnDate: function (startingTurnDate) {
			this.startingTurnDate = startingTurnDate;
			return this;
		},
		withPayedPrice: function (payedPrice) {
			this.payedPrice = payedPrice;
			return this;
		},
		build: function () {
			return new HiredTradeshowBooth(
				this.id,
				this.tradeshow,
				this.hiredTurnDate,
				this.startingTurnDate,
				this.payedPrice
			);
		}
	};
}

export default function CreateHiredTradeshowBoothModel(booth) {
	/* eslint-disable camelcase */
	return new HiredTradeshowBoothBuilder()
		.withId(booth.id)
		.withTradeshow({ id: booth.tradeshow_id })
		.withHiredTurnDate(booth.hired_turn_date)
		.withStartingTurnDate(booth.starting_turn_date)
		.withPayedPrice(booth.payed_price)
		.build()
		.toPlainObj();
	/* eslint-enable camelcase */
}
